import { DSButton, DSInput } from '@vr/ds-react';
import { useRelatorios } from './RelatoriosContext';
import { Relatorio } from '../../services/relatoriosService';
import Select from '../../components/select';
// import styles from './Relatorios.module.css';

export default function RelatoriosContent() {
  const {
    relatorios,
    loading,
    filtros,
    abaAtiva,
    filtrosAbertos,
    unidades,
    tiposRelatorio,
    statusOperacional,
    setFiltros,
    setAbaAtiva,
    toggleFiltros,
    limparFiltros,
    aplicarFiltros,
    gerarRelatorio,
    baixarArquivo,
    preVisualizarExcel,
    visualizarDados,
  } = useRelatorios();

  const abasFiltradas = {
    todos: relatorios,
    processando: relatorios.filter(r => r.status === 'Processando'),
    devolucoes: relatorios.filter(r => r.status === 'Erro')
  };

  const relatoriosFiltrados = abasFiltradas[abaAtiva as keyof typeof abasFiltradas] || relatorios;

  return (
    <div
      data-testid="page-relatorios"
      style={{ display: 'flex', flexDirection: 'column', gap: '48px', maxWidth: '1098px', margin: '0 auto', padding: '32px' }}
    >
      {/* HEADER */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
          <div>
            <h1 style={{ margin: 0 }}>Relatórios</h1>
          </div>
          <div>
            <p style={{ margin: 0 }}>Acompanhe, gere e analise relatórios dos pedidos de benefícios.</p>
          </div>
        </div>
        <DSButton
          data-testid="btn-gerar-novo-relatorio"
          variant="primary"
          onClick={gerarRelatorio}
          style={{ alignSelf: 'flex-start' }}
        >
          Gerar novo relatório
        </DSButton>
      </div>

      {/* FILTROS */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'flex-start', alignItems: 'center', gap: '48px' }}>
          <div style={{ flex: 1 }}>
            <DSInput
              data-testid="input-pesquisa"
              label="Pesquisa"
              placeholder="Pesquise por tipo de relatório, número, status ou valor"
              value={filtros.pesquisa}
              onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFiltros({ pesquisa: e.target.value })}
            />
          </div>
          <DSButton
            data-testid="btn-fechar-filtros"
            variant="ghost"
            onClick={toggleFiltros}
          >
            {filtrosAbertos ? 'Fechar filtros' : 'Abrir filtros'}
          </DSButton>
        </div>

        {filtrosAbertos && (
          <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <h3 style={{ margin: 0 }}>Filtros avançados</h3>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '24px' }}>
              <Select
                dataTestId="select-unidade"
                label="Unidade"
                placeholder="Selecione a unidade"
                options={unidades}
                type="unidade"
              />
              <Select
                dataTestId="select-tipo-relatorio"
                label="Tipo de relatório"
                placeholder="Selecione o tipo de relatório"
                options={tiposRelatorio}
                type="tipoRelatorio"
              />
              <Select
                dataTestId="select-status-operacional"
                label="Status operacional"
                placeholder="Selecione o status operacional"
                options={statusOperacional}
                type="statusOperacional"
              />
            </div>
            <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '24px' }}>
              <DSInput
                data-testid="input-periodo-inicio"
                label="Período de:"
                value={filtros.periodoInicio}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFiltros({ periodoInicio: e.target.value })}
              />
              <DSInput
                data-testid="input-periodo-fim"
                label="até:"
                value={filtros.periodoFim}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFiltros({ periodoFim: e.target.value })}
              />
              <DSInput
                data-testid="input-valor-inicio"
                label="Valor do pedido"
                value={filtros.valorInicio}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFiltros({ valorInicio: e.target.value })}
              />
              <DSInput
                data-testid="input-valor-fim"
                label="Valor do pedido"
                value={filtros.valorFim}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => setFiltros({ valorFim: e.target.value })}
              />
            </div>
            <div style={{ display: 'flex', flexDirection: 'row', gap: '16px' }}>
              <DSButton
                data-testid="btn-limpar-filtros"
                variant="ghost"
                onClick={limparFiltros}
              >
                Limpar filtros
              </DSButton>
              <DSButton
                data-testid="btn-aplicar-filtros"
                variant="primary"
                onClick={aplicarFiltros}
              >
                Aplicar filtros avançados
              </DSButton>
            </div>
          </div>
        )}
      </div>

      {/* LISTA DE RELATÓRIOS */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        <h2 style={{ margin: 0 }}>Lista de relatórios ({relatorios.length})</h2>
        <div style={{ display: 'flex', flexDirection: 'column', gap: '0' }}>
          {/* ABAS */}
          <div style={{ display: 'flex', flexDirection: 'row', gap: '0' }}>
            <button
              data-testid="aba-todos"
              style={{
                padding: '12px 24px',
                background: 'none',
                border: 'none',
                borderBottom: abaAtiva === 'todos' ? '2px solid #0066cc' : '2px solid transparent',
                cursor: 'pointer',
                fontWeight: abaAtiva === 'todos' ? 'bold' : 'normal'
              }}
              onClick={() => setAbaAtiva('todos')}
            >
              Todos os relatórios ({relatorios.length})
            </button>
            <button
              data-testid="aba-processando"
              style={{
                padding: '12px 24px',
                background: 'none',
                border: 'none',
                borderBottom: abaAtiva === 'processando' ? '2px solid #0066cc' : '2px solid transparent',
                cursor: 'pointer',
                fontWeight: abaAtiva === 'processando' ? 'bold' : 'normal'
              }}
              onClick={() => setAbaAtiva('processando')}
            >
              Processando ({abasFiltradas.processando.length})
            </button>
            <button
              data-testid="aba-devolucoes"
              style={{
                padding: '12px 24px',
                background: 'none',
                border: 'none',
                borderBottom: abaAtiva === 'devolucoes' ? '2px solid #0066cc' : '2px solid transparent',
                cursor: 'pointer',
                fontWeight: abaAtiva === 'devolucoes' ? 'bold' : 'normal'
              }}
              onClick={() => setAbaAtiva('devolucoes')}
            >
              Devoluções
            </button>
          </div>

          {/* CARDS LISTA */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '0' }}>
            {loading ? (
              <p>Carregando...</p>
            ) : (
              relatoriosFiltrados.map(relatorio => (
                <RelatorioCard
                  key={relatorio.id}
                  relatorio={relatorio}
                  onBaixar={baixarArquivo}
                  onPreVisualizar={preVisualizarExcel}
                  onVisualizar={visualizarDados}
                />
              ))
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

interface RelatorioCardProps {
  relatorio: Relatorio;
  onBaixar: (id: string) => void;
  onPreVisualizar: (id: string) => void;
  onVisualizar: (id: string) => void;
}

function RelatorioCard({ relatorio, onBaixar, onPreVisualizar, onVisualizar }: RelatorioCardProps) {
  const isBaixarDisabled = relatorio.status === 'Processando';

  const infoExtraText = relatorio.valorEmAberto && relatorio.cnpj
    ? `Valor em aberto: ${relatorio.valorEmAberto}   •   CNPJ ${relatorio.cnpj}   •  ${relatorio.periodo}`
    : relatorio.periodo;

  return (
    <div
      data-testid={`card-relatorio-${relatorio.id}`}
      style={{
        border: '1px solid #e0e0e0',
        borderRadius: '8px',
        padding: '16px',
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        marginBottom: '8px'
      }}
    >
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '8px' }}>
        <span style={{ fontWeight: 'bold' }}>{relatorio.numero} - {relatorio.titulo}</span>
        <span
          style={{
            padding: '2px 8px',
            borderRadius: '4px',
            fontSize: '12px',
            background: relatorio.status === 'Processando' ? '#fff3cd' : '#d4edda',
            color: relatorio.status === 'Processando' ? '#856404' : '#155724'
          }}
        >
          {relatorio.status}
        </span>
      </div>
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '8px' }}>
        <span style={{ fontSize: '12px', background: '#f0f0f0', padding: '2px 8px', borderRadius: '4px' }}>{relatorio.tipo}</span>
        {relatorio.tiposAdicionais > 0 && (
          <span style={{ fontSize: '12px' }}>+{relatorio.tiposAdicionais}</span>
        )}
      </div>
      <span style={{ fontSize: '12px', color: '#666' }}>{infoExtraText}</span>
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '8px' }}>
        <span style={{ fontSize: '12px', color: '#666' }}>Pedidos:</span>
        {relatorio.pedidos.map((pedido, idx) => (
          <span key={idx} style={{ fontSize: '12px' }}>{pedido}</span>
        ))}
      </div>
      <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '8px' }}>
        <DSButton
          data-testid={`btn-pre-visualizar-${relatorio.id}`}
          variant="ghost"
          onClick={() => onPreVisualizar(relatorio.id)}
        >
          Pré visualizar excel
        </DSButton>
        <DSButton
          data-testid={`btn-baixar-${relatorio.id}`}
          variant="ghost"
          disabled={isBaixarDisabled}
          onClick={() => onBaixar(relatorio.id)}
        >
          Baixar arquivo
        </DSButton>
        <DSButton
          data-testid={`btn-visualizar-${relatorio.id}`}
          variant="ghost"
          onClick={() => onVisualizar(relatorio.id)}
        >
          Visualizar dados
        </DSButton>
      </div>
      {relatorio.geradoEm && (
        <span style={{ fontSize: '12px', color: '#999' }}>{relatorio.geradoEm}</span>
      )}
    </div>
  );
}
